import { getAssetUrl } from '@/utils/asset-url';

// Image URL exports backed by the server's /assets/images endpoint.
// This preserves existing import paths without bundling static assets.

const Barprogress = getAssetUrl('barprogress.png');
const iconsidebar = getAssetUrl('iconsidebar.png');
const brain = getAssetUrl('onegov-icon.png');
const apicon = getAssetUrl('apicon.png');
const avatar = getAssetUrl('avatar.png');
const cardbg = getAssetUrl('cardbg.png');
const circles = getAssetUrl('circles.png');
const closesidebar = getAssetUrl('closesidebar.png');
const googlelogo = getAssetUrl('googlelogo.png');
const grouplogos = getAssetUrl('grouplogos.png');
const halfscreen = getAssetUrl('halfscreen.png');
const houseintern = getAssetUrl('houseinternal.png');
const internet = getAssetUrl('internet.png');
const kintsubi = getAssetUrl('kintsubi.png');
const landscapescreen = getAssetUrl('landscapscreen.png');
const mail = getAssetUrl('mail.svg');
const mainlogo = getAssetUrl('onegov-logo.png');
const mainscreen = getAssetUrl('mainscreen.png');
const meeting = getAssetUrl('meeting.png');
const mobilehand = getAssetUrl('mobilehand.png');
const mobilezoom = getAssetUrl('mobilezoom.png');
const nextgen = getAssetUrl('nextgen.png');
const pencil = getAssetUrl('pencil.png');
const peopleboard = getAssetUrl('peopleboard.png');
const progress = getAssetUrl('progress.png');
const team = getAssetUrl('team.png');
const team2 = getAssetUrl('team2.png');
const tickicon = getAssetUrl('tickicon.png');
const team1 = getAssetUrl('team1.png');
const wave = getAssetUrl('wave.png');
const mobilecard = getAssetUrl('mobilecard.png');
const cardai = getAssetUrl('cardai.png');
const facebook = getAssetUrl('facebook.svg');
const twitter = getAssetUrl('twitter.svg');
const dm = getAssetUrl('dm.svg');
const instagram = getAssetUrl('instagram.svg');
const helpherobg = getAssetUrl('helphero.png');
const blog1 = getAssetUrl('blog1.png');
const blog2 = getAssetUrl('blog2.png');
const blog3 = getAssetUrl('blog3.png');
const careerbanner = getAssetUrl('careerbanner.png');
const facebook_btn = getAssetUrl('facebook_btn.png');
const twitter_btn = getAssetUrl('twitter_btn.png');
const copylink_btn = getAssetUrl('copylink_btn.png');
const linkedin_btn = getAssetUrl('linkedin_btn.png');
const blog_content_poster = getAssetUrl('blog_content_poster.png');
const blog_content_poster2 = getAssetUrl('blog_content_poster2.png');
const blog_1 = getAssetUrl('blog_1.png');
const blog_2 = getAssetUrl('blog_2.png');
const blog_3 = getAssetUrl('blog_3.png');
const blog_4 = getAssetUrl('blog_4.png');
const searchglass = getAssetUrl('searchglass.svg');
const messageicon = getAssetUrl('messageicon.svg');
const report_icon1 = getAssetUrl('report_icon1.png');
const report_icon2 = getAssetUrl('report_icon2.png');
const report_icon3 = getAssetUrl('report_icon3.png');
const track_1 = getAssetUrl('track_1.png');
const track_2 = getAssetUrl('track_2.png');
const track_3 = getAssetUrl('track_3.png');
const track_4 = getAssetUrl('track_4.png');
const track_5 = getAssetUrl('track_5.png');
const track_6 = getAssetUrl('track_6.png');
const right_arrow = getAssetUrl('arrow-right.png');
const search_poster1 = getAssetUrl('search_poster1.png');
const policy_banner = getAssetUrl('policy_banner.png');
const policy_banner2 = getAssetUrl('policy_banner2.png');
const alert_banner1 = getAssetUrl('alert_banner1.png');
const alert_banner2 = getAssetUrl('alert_banner2.png');
const manage_banner1 = getAssetUrl('manage_banner1.png');
const manage_banner2 = getAssetUrl('manage_banner2.png');
const manage_banner3 = getAssetUrl('manage_banner3.png');
const manage_banner4 = getAssetUrl('manage_banner4.png');
const regular_doc = getAssetUrl('regular_doc.png');
const neight_1 = getAssetUrl('neight_1.png');
const neight_2 = getAssetUrl('neight_2.png');
const neight_3 = getAssetUrl('neight_3.png');
const legislativeAI = getAssetUrl('legislative_ai.png');
const aiApproach = getAssetUrl('ai_approach.jpg');
const automatization = getAssetUrl('automatization.jpg');
const practical = getAssetUrl('practical.png');
const results = getAssetUrl('results.png');
const challengeImage = getAssetUrl('challengeImage.png');
const transparencyImage = getAssetUrl('transparencyImage.png');
const coverageGapImage = getAssetUrl('coverageGapImage.png');
const impactImage = getAssetUrl('impactImage.png');
const strategicAdvantages = getAssetUrl('strategicAdvantages.png');
const implementationImage = getAssetUrl('implementationImage.png');
const democracy = getAssetUrl('democracy.png');
const growth = getAssetUrl('grow.png');
const madeline = getAssetUrl('madeline.jpeg');
const cooper = getAssetUrl('cooper.jpeg');
const josh = getAssetUrl('josh.jpeg');
const LobbyPortal = getAssetUrl('LobbyPortal.png');
const img2 = getAssetUrl('img2.png');
const Automation = getAssetUrl('Automation.png');
const Alerts = getAssetUrl('Alerts.png');
const impact = getAssetUrl('impact.png');
const matt_avatar = getAssetUrl('matt_avatar.jpeg');
const jw_avatar = getAssetUrl('jw_avatar.jpeg');
const jn_avatar = getAssetUrl('jn_avatar.jpeg');
const pete_avatar = getAssetUrl('pete_avatar.jpeg');
const josh_avatar = getAssetUrl('josh_avatar.png');
const msa = getAssetUrl('msa.png');
const bll = getAssetUrl('bll.png');
const bpa = getAssetUrl('bpa.png');
const legiscon = getAssetUrl('legiscon.png');
const telicon = getAssetUrl('telicon.png');
const tags = getAssetUrl('tags.png');
const ai_report_page = getAssetUrl('lobby2.png');
const transcript_page = getAssetUrl('transcript_page.png');
const lobby = getAssetUrl('Lobby1.png');
const dashboard2 = getAssetUrl('Dashboard2.png');
// Primary chat bubble image; if missing in a given env, fall back in component
const plasticIQ = getAssetUrl('plasticIQ.png');
// Fallback logo used when plasticIQ.jpg is unavailable
const logoSmall = getAssetUrl('logo-small.png');

// Report type carousel images
const aibillanalysis = getAssetUrl('aibillanalysis.png');
const billreport = getAssetUrl('billreport.png');
const votereport = getAssetUrl('votereport.png');
const trackedactivityreport = getAssetUrl('trackedactivityreport.png');

// Portal and feature screenshots
const advancedSearchOptions = getAssetUrl('AdvancedSearchOptions.png');
const advancedSearchReport = getAssetUrl('advancedSearchReport.png');
const agentAutoTrackedBills = getAssetUrl('agentautoTrackedBills.png');
const sortAgenticTrack = getAssetUrl('sortAgenticTrack.png');
const billSearchPreview = getAssetUrl('billPage.png');
const committeeSummaryClip = getAssetUrl('transcriptsHub.png');
const transcriptsHub = getAssetUrl('transcriptWitness.png');
const committeesWithHearings = getAssetUrl('Committees.png');
const membersWithRankings = getAssetUrl('mempage.png');
const versionCompare = getAssetUrl('versionCompare.png');
const aiversionCompare = getAssetUrl('aiversionCompare.png');
const stats = getAssetUrl('stats1.png');
const regulations = getAssetUrl('statute.png');
const campaign_finance = getAssetUrl('cont.png');
const reports_page_search_open = getAssetUrl('reports_page_search_open.png');

export {
  msa,
  bll,
  bpa,
  legiscon,
  telicon,
  Barprogress,
  iconsidebar,
  apicon,
  avatar,
  cardbg,
  circles,
  closesidebar,
  googlelogo,
  grouplogos,
  halfscreen,
  houseintern,
  internet,
  kintsubi,
  landscapescreen,
  mail,
  mainlogo,
  mainscreen,
  meeting,
  mobilehand,
  mobilezoom,
  nextgen,
  pencil,
  peopleboard,
  progress,
  team,
  team1,
  team2,
  tickicon,
  wave,
  brain,
  mobilecard,
  cardai,
  facebook,
  twitter,
  dm,
  instagram,
  helpherobg,
  blog1,
  blog2,
  blog3,
  careerbanner,
  facebook_btn,
  twitter_btn,
  copylink_btn,
  linkedin_btn,
  blog_content_poster,
  blog_content_poster2,
  blog_1,
  blog_2,
  blog_3,
  blog_4,
  searchglass,
  messageicon,
  report_icon1,
  report_icon2,
  report_icon3,
  track_1,
  track_2,
  track_3,
  track_4,
  track_5,
  track_6,
  right_arrow,
  search_poster1,
  policy_banner,
  policy_banner2,
  alert_banner1,
  alert_banner2,
  manage_banner1,
  manage_banner2,
  manage_banner3,
  manage_banner4,
  regular_doc,
  neight_1,
  neight_2,
  neight_3,
  legislativeAI,
  aiApproach,
  automatization,
  practical,
  results,
  challengeImage,
  transparencyImage,
  coverageGapImage,
  impactImage,
  strategicAdvantages,
  implementationImage,
  democracy,
  growth,
  madeline,
  cooper,
  josh,
  LobbyPortal,
  img2,
  Automation,
  Alerts,
  impact,
  matt_avatar,
  jw_avatar,
  jn_avatar,
  pete_avatar,
  josh_avatar,
  tags,
  lobby,
  ai_report_page,
  transcript_page,
  dashboard2,
  plasticIQ,
  logoSmall,
  aibillanalysis,
  billreport,
  votereport,
  trackedactivityreport,
  advancedSearchOptions,
  advancedSearchReport,
  agentAutoTrackedBills,
  sortAgenticTrack,
  billSearchPreview,
  committeeSummaryClip,
  transcriptsHub,
  committeesWithHearings,
  membersWithRankings,
  versionCompare,
  aiversionCompare,
  stats,
  regulations,
  campaign_finance,
  reports_page_search_open,
};
